import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  loadingBar: (props) => ({
    height: `${theme.sizes.base / 2}px`,
    overflow: 'hidden',
    direction: 'ltr',
    textAlign: 'left',
    position: 'relative',
    '& > .inside': {
      position: 'absolute',
      background: theme.colors[props.color].normal,
      width: '90%',
      height: '100%',
      animation: `$insideOut ${theme.speed.normal * 4}ms infinite linear`,
      overflow: 'hidden',
      '& > .inside': {
        position: 'absolute',
        background: theme.colors[props.color].border,
        width: '50%',
        height: '100%',
        animation: `$insideOut ${theme.speed.normal * 4}ms infinite linear`,
      },
    },
  }),
  '@keyframes insideOut': {
    from: {
      transform: 'translateX(-100%)',
      left: '0%',
    },
    to: {
      transform: 'translateX(0%)',
      left: '100%',
    },
  },
}));

export default useStyle;
